export enum Variant {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}
